import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type ButtonsAlign } from "@common/contexts/FormStyle";
import ButtonsContainer from "@common/controls/Container/Buttons";
import * as React from "react";
import { Button } from "./Button";
import Form from "./Form/container";
import Modal from "./Modal/container";

import "./style.less";

export type OptInFormComponentMapProps = RootContainerProps & {
  buttonsAlign?: ButtonsAlign;
  display: "page" | "popup";
};

export type OptInFormComponentActionProps = {
  showModal: (e: React.MouseEvent<any>) => void;
};

type Props = OptInFormComponentActionProps & OptInFormComponentMapProps;

export default (props: Props) => (
  <Container {...getContainerProps(props)}>
    {props.display === "page" && <Form {...getRootContainerProps(props)} isInPopup={false} />}
    {props.display === "popup" && (
      // display: "flex", flexDirection: "column" fixes button horizontal align
      <ButtonsContainer align={props.buttonsAlign ?? "left"}>
        <Button {...getRootContainerProps(props)} onClick={props.showModal} isEditMode={false} />
        <Modal {...props} />
      </ButtonsContainer>
    )}
  </Container>
);
